'use client'
import type { Product } from 'product/types'
import type { GetProductInfoProps } from 'product/types/ProductInfo'
import { useMemo } from 'react'
import { fetcher } from 'services/rest/fetcher'
import useSWRImmutable from 'swr/immutable'
import { getClientProductInfoUrl } from './getClientProductInfoUrl'

export const useProductInfo = ({
	language,
	country,
	productId,
	enabled = true, // This property is for calling the hook on demand, a flow that we need to manage the related products in the product card.
}: GetProductInfoProps) => {
	const fetchUrl = getClientProductInfoUrl({
		productId,
		countryISO: country,
		languageISO: language,
	})

	const {
		data: product,
		isLoading,
		mutate,
		error,
	} = useSWRImmutable<Product>(enabled ? fetchUrl : null, fetcher, {
		revalidateOnMount: true,
	})

	return useMemo(
		() => ({
			data: product ? { ...product, id: productId } : undefined,
			isLoading,
			mutate,
			error,
		}),
		[product, productId, isLoading, mutate, error]
	)
}
